export const iconSizes = {
  icon8: 8,
  icon12: 12,
  icon16: 16,
  icon18: 18,
  icon20: 20,
  icon24: 24,
  icon28: 28,
  icon32: 32,
  icon36: 36,
  icon40: 40,
  icon44: 44,
  icon48: 48,
  icon64: 64,
  icon70: 70,
  icon100: 100,
}
